import React from "react"
import Header from "./header"
import Footer from "./footer"
import * as styles from "./page.module.css"

interface PageProps {
	title?: string
	description?: string
	children?: React.ReactNode
	navHighlight?: string // New prop for highlighting nav items
}

export default function Page({children, navHighlight}: PageProps) {
	return (
		<div className={`${styles.container} container`}>
			<div className={styles.inner}>
				<Header navHighlight={navHighlight} />
				<main>{children}</main>
				<Footer />
			</div>
		</div>
	)
}
